module.exports = "./img/desktop_logo.1be88a5.png";